define( function() {
	"use strict";

	return [ "Top", "Right", "Bottom", "Left" ];
} );



//////////////////
// WEBPACK FOOTER
// ./~/_jquery@3.6.0@jquery/src/css/var/cssExpand.js
// module id = 259
// module chunks = 0